import styled from "@emotion/styled";
import rem from "../../../../utils/rem/rem";


export const StyledTableWrapper = styled.div`
  height: 60vh;
  display: flex;
  gap: ${rem(16)} 32px;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  align-content: space-between;
  flex-direction: row;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  border-right: 1px solid ${({ theme }) => theme.colors.gray400};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  @media only screen and ${({ theme }) => theme.breakpoints.xl} {
    flex-direction: column;
  }
`;

export const HeaderInputButton = styled.span`
  padding: 6px 16px 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  button:first-of-type {
    margin: 0;
    margin-top: ${rem(10)};
  }
  
`;

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  gap: ${rem(16)} 32px;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    flex-direction: column;
  }
`;
export const TableWrapper = styled.div`
width: calc(60vw - 232px);
min-width: ${rem(396)};
height: 100%;

@media ${({ theme }) => theme.breakpoints.lg} {
  width: 100%;
}
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  gap: ${rem(16)} 24px;
  aling-items: left;
  flex: 0.5;
`;

export const StyledSubTitle = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(16)};
  margin: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const InputButtonWrapper = styled.div`
  div {
    width: ${rem(215)};
  }
  flex-direction: row;
  aling-item: center;
  justify-content: center;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  gap: ${rem(30)} 10px;
  flex: 1;
`;

export const StyledHeaderTitle = styled.div`
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: ${rem(20)};
  margin: 16px;
`;